import React, { useCallback } from 'react';

const useDraggableValue = (prefix = '') => {
  const customCellRender = useCallback((e) => {
    const val = `${prefix}${e.displayValue}`;

    return (
      <div
        className="draggable"
        data-row-val={val}
        onDragStart={(ev) => {
          ev.dataTransfer.setData('name', val);
        }}
        draggable
      >
        {e.displayValue}
      </div>
    );
  }, []);

  return customCellRender;
};

export default useDraggableValue;
